import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Box,
  CircularProgress,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { investorApi } from "../../../api/api";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const WalletTransaction = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const userId = useSelector((state) => state.user.userId);
  const navigate = useNavigate();
  const theme=useSelector((data)=>data.themeValue.colors)
  const themeMode=useSelector((data)=>data.themeValue.theme)

  useEffect(() => {
     window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchTransaction = async () => {
      try {
        const response = await investorApi.getTransactionDetails(userId);
        if (Array.isArray(response.data)) {
          setTransactions(response.data);
        } else {
          console.warn("Invalid response format.");
        }
      } catch (error) {
        console.error("Error fetching transaction details:", error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchTransaction();
  }, [userId]);

  const getStatusIcon = (status) => {
    const normalized = status.toLowerCase();
    if (normalized === "completed")
      return <CheckCircleOutlineIcon sx={{ fontSize: 28, color: "#2e7d32" }} />;
    if (normalized === "inprogress")
      return <AccessTimeIcon sx={{
        fontSize: {
          xs: 20,
          sm: 24,
          md: 28,
        }, color: "#f9a825"
      }} />;
    if (normalized === "rejected")
      return <HighlightOffIcon sx={{ fontSize: 28, color: "#d32f2f" }} />;
    return null;
  };

  const getStatusColor = (status) => {
    const normalized = status.toLowerCase();
    if (normalized === "completed") return "#2e7d32";
    if (normalized === "inprogress") return "#f9a825";
    if (normalized === "rejected") return "#d32f2f";
    return "#757575";
  };

  return (
    <Container sx={{ mt: 5, mb: 5, width: "100%"}}>
      <Typography
        variant="h5"
        fontWeight="bold"
        sx={{ mb: 3, color: theme.text }}
      >
        Wallet Transactions
      </Typography>

      {loading ? (
        <Box sx={{ textAlign: "center", py: 5 }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Loading transactions...</Typography>
        </Box>
      ) : transactions.length === 0 ? (
        <Typography sx={{ textAlign: "center", color: "#888" }}>
          No transactions found.
        </Typography>
      ) : (
        transactions.map((tx) => {
          const statusColor = getStatusColor(tx.status);
          return (
            <Paper
              key={tx.id}
              elevation={3}
              sx={{
                mb: 3,
                backgroundColor:themeMode==="light"?"#fcfcfc":"#c2c2c2",
                p: 3,
                borderRadius: 3,
                cursor:
                  tx.status.toLowerCase() === "pending" ? "pointer" : "default",
                transition: "0.3s",
                "&:hover": {
                  boxShadow:
                    tx.status.toLowerCase() === "pending"
                      ? "0 6px 18px rgba(0,0,0,0.12)"
                      : "0 4px 12px rgba(0,0,0,0.06)",
                },
              }}
              onClick={
                tx.status.toLowerCase() === "pending"
                  ? () =>
                    navigate("/WalletPending", {
                      state: { id: tx.id, Amount: tx.Amount },
                    })
                  : undefined
              }
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                 
                }}
              >
                {/* Left side */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    width: {
                      xs: "50%",
                      sm: "50%",
                      md: "30%",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: { 
                        xs: 30,
                        sm: 40,
                        md: 60,
                      },
                      height: {
                        xs: 30,
                        sm: 40,
                        md: 60,
                      },
                      borderRadius: "50%",
                      backgroundColor: `${statusColor}22`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {getStatusIcon(tx.status)}
                  </Box>

                  <Box>
                    <Typography
                      fontSize={{
                        xs: 12,
                        sm: 15,
                        md: 20,
                      }}
                      fontWeight="bold"
                      color={
                        tx.Type.toLowerCase() === "credit"
                          ? "#2e7d32"
                          : "black"
                      }
                    >
                      {tx.Type.toLowerCase() === "credit" ? "+" : " "} ₹
                      {tx.Amount}
                    </Typography>
                    <Typography fontSize={{
                      xs: 10,
                      sm: 13,
                      md: 18,
                    }} variant="caption" color="text.secondary">
                      {new Date(tx.createdAt).toLocaleDateString()}
                    </Typography>
                  </Box>
                </Box>

                {/* Right side */}
                <Box sx={{
                  textAlign: "right", width: {
                    xs: "50%",
                    sm: "30%",
                    md: "40%",
                  }
                }}>
                  <Typography fontWeight="bold" sx={{ color: statusColor }}>
                    {tx.status}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#555" }}>
                    {tx.Comments || "No description"}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          );
        })
      )}
    </Container>
  );
};

export default WalletTransaction;
